import React, { useState, useEffect } from 'react';
import { createClient } from "@supabase/supabase-js";
import supabase from '../../utils/supabaseClient';

function AddFamilia({ onClose, familias = [] }) {
  
  // Calculate the next available number
  const getNextNumber = () => {
    if (familias.length === 0) return 1;
    const maxNumber = Math.max(...familias.map(f => f.number || 0));
    return maxNumber + 1;
  };

  const [form, setForm] = useState({
    nombre: '',
    number: getNextNumber()
  });
  const [message, setMessage] = useState('');
  // eslint-disable-next-line no-unused-vars
  const [user, setUser] = useState(null);

  // Update the default number when familias prop changes
  useEffect(() => {
    setForm(prev => ({ ...prev, number: getNextNumber() }));
  }, [familias]);

  useEffect(() => {
    supabase.auth.getUser().then(({ data: { user } }) => setUser(user));
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      setUser(session?.user ?? null);
    });
    return () => {
      listener.subscription.unsubscribe();
    };
  }, [supabase.auth]);

  async function handleSave(e) {
    e.preventDefault();
    setMessage('');
    
    const insertData = { nombre: form.nombre };
    
    // Only include number if it's provided
    if (form.number !== '') {
      insertData.number = parseInt(form.number);
    }
    
    const { error } = await supabase.from('familia').insert([insertData]);
    if (error) {
      setMessage('Error al agregar familia');
    } else {
      setMessage('¡Familia agregada!');
      setForm({ nombre: '', number: getNextNumber() });
      setTimeout(() => {
        if (onClose) onClose();
      }, 1000);
    }
  }

  return (
    <>
      <div style={{ maxWidth: 400, margin: '40px auto', padding: 24, borderRadius: 8, background: '#f7f7f7' }}>
        <h2 style={{ textAlign: 'center', marginBottom: 24 }}>Agregar Familia</h2>
        <div style={{
          maxWidth: 400,
          padding: 32,
          borderRadius: 12,
          background: '#fff',
          boxShadow: '0 4px 24px rgba(0,0,0,0.10)'
        }}>
          <button
            onClick={onClose}
            style={{
              position: 'absolute',
              top: 12,
              right: 16,
              background: 'none',
              border: 'none',
              fontSize: 22,
              cursor: 'pointer',
              color: '#e60026',
              zIndex: 10
            }}
            title="Cerrar"
          >×</button>
          <h2 style={{
            textAlign: 'center',
            marginBottom: 28,
            color: '#e60026',
            letterSpacing: 1,
            fontWeight: 700
          }}>
            Agregar Familia
          </h2>
          <form onSubmit={handleSave} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
            <label style={{ fontWeight: 500 }}>
              Nombre:
              <input
                value={form.nombre}
                onChange={e => setForm(f => ({ ...f, nombre: e.target.value }))}
                required
                style={{
                  width: '100%',
                  padding: 8,
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  marginTop: 4
                }}
              />
            </label>
            <label style={{ fontWeight: 500 }}>
              Orden (número):
              <input
                type="number"
                value={form.number}
                onChange={e => setForm(f => ({ ...f, number: e.target.value }))}
                placeholder="Ingresa un número para ordenar"
                min="1"
                style={{
                  width: '100%',
                  padding: 8,
                  borderRadius: 6,
                  border: '1px solid #ccc',
                  marginTop: 4
                }}
              />
            </label>
            <small style={{ color: '#666', fontSize: '12px', marginTop: '-8px' }}>
              El orden determina cómo aparecen las familias en los filtros. 
              Números más bajos aparecen primero.
            </small>
            <button
              type="submit"
              style={{
                background: '#e60026',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                padding: '10px 0',
                fontWeight: 600,
                fontSize: 16,
                marginTop: 10,
                boxShadow: '0 2px 8px rgba(0,0,0,0.07)',
                cursor: 'pointer',
                transition: 'background 0.2s'
              }}
              onMouseOver={e => (e.currentTarget.style.background = '#b8001b')}
              onMouseOut={e => (e.currentTarget.style.background = '#e60026')}
            >
              Agregar
            </button>
            {message && (
              <div style={{
                marginTop: 12,
                color: message === '¡Familia agregada!' ? 'green' : '#e60026',
                fontWeight: 600,
                textAlign: 'center'
              }}>
                {message}
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
}

export default AddFamilia;